"use client";
/* eslint-disable @next/next/no-img-element */
import { addFilter, filterItems } from "@/redux/features/filterSlice";
import { APP_NAME, emptyFilter } from "@/utils/enum";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useRouter } from "next/navigation";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";

const PropertyOne = ({ data }: any) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const filter = useSelector(filterItems);
  const isVibgyorOne = [
    APP_NAME.VIBGYOR_ONE,
    APP_NAME.SUMMER_CAMP_PRIVATE,
  ].includes(process.env.NEXT_PUBLIC_APP_NAME as APP_NAME);
  const sliderRef = useRef<Slider | null>(null);

  const multiple = data.length > 1;

  const settings = {
    dots: false,
    arrows: false,
    infinite: multiple,
    speed: 500,
    autoplay: multiple,
    autoplaySpeed: 4500,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: multiple,
    centerPadding: "24px",
    pauseOnHover: true,
    dotsClass: "slick-dots hero-dots",
    responsive: [
      {
        breakpoint: 1400,
        settings: { slidesToShow: 3, centerPadding: "16px" },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2, centerPadding: "8px" },
      },
      {
        breakpoint: 550,
        settings: { slidesToShow: 1, centerPadding: "0px" },
      },
    ],
  };

  if (!data || data.length === 0) return null;
  return (
    <>
      <style>{`
        .feat-section {
          background: #fff;
          padding: 4rem 0;
        }
        .feat-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }
        .feat-header {
          margin-bottom: 2rem;
        }
        .feat-card {
          position: relative;
          flex: 1 1 0;
          aspect-ratio: 1 / 1;
          border-radius: 1rem;
          overflow: clip;
          display: block;
          text-decoration: none;
          background: #eef0f8;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
          transition: box-shadow 0.25s;
        }
        .feat-card:hover { box-shadow: 0 8px 28px rgba(0,0,0,0.14); }
        .feat-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.35s;
        }
        .feat-card:hover img { transform: scale(1.04); }
        .feat-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 1.25rem 1.25rem 1rem;
          background: linear-gradient(to top, rgba(0,0,0,0.72) 0%, transparent 100%);
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          gap: 0.5rem;
        }
        .feat-card-title {
          color: #fff;
          font-size: 1.05rem;
          font-weight: 600;
          font-family: Graphik, sans-serif;
          line-height: 1.4;
          flex: 1;
        }
        .feat-arrow {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: rgba(255,255,255,0.5);
          border: 1.5px solid rgba(255,255,255,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: background 0.2s;
        }
        .feat-card:hover .feat-arrow { 
          background: #3f41d1; 
          border-color: #3f41d1; 
        }
        .feat-arrow-left,
        .feat-arrow-right {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 48px;
          height: 48px;
          border: none;
          border-radius: 50%;
          background: rgba(255,255,255,0.5);
          border: 1.5px solid rgba(255,255,255,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          z-index: 10;
          transition: all 0.25s ease;
        }        
        .feat-slider-wrap {
          position: relative;
          padding: 0 60px;
        }
        .feat-arrow-left {
          left: 0;
        }
        .feat-arrow-right {
          right: 0;
        }
        .feat-card:hover .feat-arrow { 
          background: #3f41d1; 
          border-color: #3f41d1; 
        }
        @media (max-width: 600px) {
          .feat-slider-wrap {
            padding: 0px;
          }
        }
      `}</style>

      <section className="feat-section">
        <div className="feat-container">
          <div className="feat-header">
            <div
              className="section-label"
              style={{
                fontSize: "0.75rem",
                fontWeight: 600,
                color: "#3f41d1",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                marginBottom: "0.35rem",
              }}
            >
              Highlights
            </div>
            <h2
              style={{
                fontSize: "1.6rem",
                fontWeight: 700,
                color: "#1a1a1a",
                margin: 0,
                fontFamily: "Graphik, sans-serif",
              }}
            >
              {isVibgyorOne ? "Featured Activities" : "Featured Events"}
            </h2>
            <p
              style={{
                color: "#666",
                fontSize: "0.95rem",
                margin: "0.35rem 0 0",
                fontFamily: "Graphik, sans-serif",
              }}
            >
              {isVibgyorOne
                ? "Explore Activities for registration."
                : "Explore Events for registration."}
            </p>
          </div>

          <div className="feat-grid">
            {/* Large main card */}
            {/* <a href={data[0]?.URL} className="feat-card feat-main">
              <Image
                src={data[0]?.Image_Path}
                alt={data[0]?.Title || "Event"}
                fill
                style={{ objectFit: "cover" }}
              />
              <div className="feat-overlay">
                <span className="feat-card-title">{data[0]?.Title}</span>
                <span className="feat-arrow">
                  <i
                    className="bi bi-arrow-up-right"
                    style={{ fontSize: "16px", color: "#fff" }}
                  ></i>
                </span>
              </div>
            </a> */}

            {/* Two stacked side cards */}
            <div className="feat-slider-wrap">
              <button
                className="feat-arrow-left"
                onClick={() => sliderRef.current?.slickPrev()}
              >
                <ChevronLeft />
              </button>
              <Slider {...settings} ref={sliderRef} className="feat-slick">
                {data.map((item: any, idx: number) => (
                  <a
                    key={idx}
                    href={item?.URL}
                    className="feat-card feat-side cursor-pointer"
                  >
                    <img src={item?.Image_Path} alt={item?.Title || "Event"} />
                    <div className="feat-overlay">
                      <span
                        className="feat-card-title"
                        style={{ fontSize: "0.95rem" }}
                      >
                        {item?.Title}
                      </span>
                      <span className="feat-arrow">
                        <i
                          className="bi bi-arrow-up-right"
                          style={{ fontSize: "14px", color: "#fff" }}
                        ></i>
                      </span>
                    </div>
                  </a>
                ))}
              </Slider>
              <button
                className="feat-arrow-right"
                onClick={() => sliderRef.current?.slickNext()}
              >
                <ChevronRight />
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PropertyOne;
